ready().then(function() {

    /**
     *  Add custom CSS classes on a booklist - to check whether it should be a flex or grid container, without affecting the html in the plugin
     */
    const addCustomBookListClasses = () => {
        let bookLists = $('.book-list-container');
        let bookListSection = $('.section-book-list:not(.section-book-list-slider)');

        bookLists.each(function() {
            let uiGridItem = $(this).find('.ui-grid-item');

            if(uiGridItem.length > 0 && uiGridItem.length < 5) { // if there are less then 5 items in the grid - we want to make it a flex-container
                $(this).addClass('is-flex-container');
            }
        });

        bookListSection.each(function() {
            let bookshelfId = $(this).attr('id');
            
            if(! $(this).hasClass('section-book-list-tabs') ) {
                if(bookshelfId === 'featured_books') { // related books need to deleted after related books becomes a tab a like
                    $(this).addClass('is-featured-book-list');
                }
            }
        });
    }

    addCustomBookListClasses();

});
